import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class CancelReservationModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      showTripInsuranceModal: false,
      cancellationReason: "",
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.closeTripInsuranceModal = this.closeTripInsuranceModal.bind(this)
    this.proceedFromTripInsurance = this.proceedFromTripInsurance.bind(this)
    this.save = this.save.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  openModal() {
    if (this.props.hasActiveTripInsurance) {
      this.setState({ showTripInsuranceModal: true })
    } else {
      this.setState({ showModal: true })
    }
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  closeTripInsuranceModal() {
    this.setState({ showTripInsuranceModal: false })
  }

  proceedFromTripInsurance() {
    this.setState({ showTripInsuranceModal: false, showModal: true })
  }

  save() {
    this.setState({ saving: true })
    this.submit({
      method: "delete",
      cancellation_reason: this.state.cancellationReason,
    })
  }

  submit(params) {
    $.delete(this.props.endpoint, params, () => {
      location.reload()
    }).fail((data) => {
      let error = "Failed to cancel."
      if (data.responseText && JSON.parse(data.responseText).error) {
        error = JSON.parse(data.responseText).error
      }
      this.setState({ errorMessage: error, saving: false })
    })
  }

  handleChange(event) {
    this.setState({
      cancellationReason: event.target.value,
    })
  }

  invalidCancellationReason() {
    return this.state.cancellationReason.trim().length === 0
  }

  render() {
    return (
      <span>
        <button
          type="button"
          className={this.props.btnClassName}
          onClick={this.openModal}
          dangerouslySetInnerHTML={{
            __html:
              "<i class='icon icon-times text-xs mr-2'></i>" +
              this.props.btnName,
          }}
        />
        <Modal
          isOpen={this.state.showTripInsuranceModal}
          onClose={this.closeTripInsuranceModal}
          size="mediumFixed"
        >
          <Modal.Header title={this.props.tripInsuranceModalTitle} />

          <Modal.Body>
            <p
              dangerouslySetInnerHTML={{
                __html: this.props.tripInsuranceModalMessageHtml,
              }}
            />
          </Modal.Body>

          <Modal.Footer
            cancelBtnText={this.props.tripInsuranceModalBack}
            confirmBtnText={this.props.tripInsuranceModalContinue}
            onClose={this.closeTripInsuranceModal}
            onSubmit={this.proceedFromTripInsurance}
          />
        </Modal>
        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="mediumFixed"
        >
          <Modal.Header title="Are you sure you want to cancel?" />

          <Modal.Body>
            <p>
              By canceling your reservation you agree to the marina&apos;s&nbsp;
              <a
                rel="noreferrer"
                target="_blank"
                href={this.props.cancellationPolicy}
              >
                cancellation policy
              </a>
              .<br />
              <b>Please enter a reason for canceling your reservation.</b>
            </p>
            <textarea
              className="form-control"
              type="text"
              value={this.state.cancellationReason}
              onChange={this.handleChange}
            />
            {this.state.errorMessage && (
              <div className="alert alert-danger mt-3" role="alert">
                {this.state.errorMessage}
              </div>
            )}
          </Modal.Body>

          <Modal.Footer
            cancelBtnText="Back"
            confirmBtnText={
              this.state.saving ? "Cancelling.." : "Cancel Reservation"
            }
            confirmBtnVariant="danger"
            confirmBtnLoading={this.state.saving}
            onClose={this.closeModal}
            onSubmit={this.save}
            disabled={this.invalidCancellationReason()}
          />
        </Modal>
      </span>
    )
  }
}

CancelReservationModal.propTypes = {
  endpoint: PropTypes.string.isRequired,
  cancellationPolicy: PropTypes.string.isRequired,
  btnClassName: PropTypes.string.isRequired,
  btnName: PropTypes.string.isRequired,
  hasActiveTripInsurance: PropTypes.bool,
  tripInsuranceModalTitle: PropTypes.string,
  tripInsuranceModalMessageHtml: PropTypes.string,
  tripInsuranceModalContinue: PropTypes.string,
  tripInsuranceModalBack: PropTypes.string,
}

CancelReservationModal.defaultProps = {
  hasActiveTripInsurance: false,
  tripInsuranceModalTitle: "",
  tripInsuranceModalMessageHtml: "",
  tripInsuranceModalContinue: "",
  tripInsuranceModalBack: "",
}

export default CancelReservationModal
